import { render, staticRenderFns } from "./MeterAreaModal.vue?vue&type=template&id=10823cb4&scoped=true"
import script from "./MeterAreaModal.vue?vue&type=script&lang=js"
export * from "./MeterAreaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10823cb4",
  null
  
)

export default component.exports